import senarai from '../../assets/senarai.png';
import typing from '../../assets/Typing-bro 1.png';
import display from '../../assets/display.png';
import spelling from '../../assets/spelling.png';
import capitalization from '../../assets/capitalization.png';
import no_suggestions from '../../assets/Ok-bro.png';
import register from '../../assets/register.png';
import success from '../../assets/success.png';
import not_found from '../../assets/not-found.png';

const images = {
  senarai,
  typing,
  display,
  spelling,
  capitalization,
  no_suggestions,
  register,
  success,
  not_found
};

export default images;
